<template>
  <v-card elevation="7">
    <v-progress-linear 
      v-if="in_loading || loading_update || !view_ready || !init_ready"
      height="10"
      color="accent"
      indeterminate
    ></v-progress-linear>
    <div class="d-flex mt-0 align-stretch flex-column flex-sm-row">
      <div class="my-4 mx-6 justify-center align-center d-flex">
        <v-img 
          contain 
          position="center"
          max-width="90"
          max-height="90"
          :src="image"
        ></v-img>
      </div>
      <div class="">
        <div 
          class="py-6 mx-2 text--darken-3 no-wrap"
          :style="{'color': title_color}"
          :class="{'text-center': !page}"
        >
          <p class="display-2 font-weight-bold mb-0" v-if="title">{{title}}<br></p>
          <p class="display-1 mb-0" :class="{'font-weight-bold': !page}">
            {{subtitle}}
          </p>
        </div>
      </div>
      <v-sheet class="my-4 mx-6 align-center d-flex ml-auto accent--text">
        <v-select
          _filled
          outlined
          v-model="new_current_period"
          :items="periods"
          hide-details
          return-object
          item-text="year"
          color="accent"
          class="accent--text"
          style="width: 100px;"
          @change="changeYear()"
          label="Año mostrado"
          :loading="loading_update"
        ></v-select>
      </v-sheet>
    </div>
  </v-card>
</template>

<script>

import { mapState, } from "vuex";
import homeMixin from "../homeMixin";
import homeHolderMixin from "../homeHolderMixin";
import * as d3 from 'd3';

export default {
  name: 'SecondHeader',
  mixins: [homeMixin, homeHolderMixin],
  props:{
    axis:{
      type: Object,
      required: false,
    },
    ies:{
      type: Object,
      required: false,
    },
    periods:{
      type: Array,
      required: false,
    },
  },
  data(){
    return {
      new_current_period: undefined,
      category: {'color':'#85137b'},
    }
  },
  computed:{
    ...mapState({
      last_values: state => state.last_values,
      current_period: state => state.current_period,
      loading_update: state => state.loading_update,
      view_ready: state => state.view_ready,
      init_ready: state => state.init_ready,
      in_loading: state => state.in_loading,
    }),
    page(){
      if (this.axis) 
        return this.axis
      else if (this.ies)
        return this.ies
      else
        return null
    },
    image(){
      //if (this.page) 
      if (this.ies) {
        return this.page.logo
        //return `${this.page.logo.split('localhost:8000').join('onigies.unam.mx')}`
      }
        //return `https://onigies.unam.mx${this.page.logo}`
      //:src=""
      else if (this.axis)
        return this.page.logo
      else
        return 'https://onigies.unam.mx/media/onigies-logo.png'
    },
    title_color(){
      return this.axis ? this.axis.color : 'black'
    },
    title(){
      if (this.axis)
        return  this.axis.nombre_corto
      else if (this.ies)
        return this.ies.siglas
      else
        return null
    },
    subtitle(){
      return this.page ? this.page.nombre : `Observatorio Nacional para la 
        Igualdad de Género en las Instituciones de Educación Superior`
    },
    color_select(){
      if (this.axis)
        return this.axis.initial_color
      else{
        const new_color = d3.rgb(this.color_idx).brighter(1.2)
        return new_color.formatHex()
      }

      const init_color = this.axis ? this.axis.initial_color : this.color_idx
      return init_color
      console.log(init_color)
      console.log(new_color)
      console.log(new_color.formatHex())

      //return d3.rgb(this.title_color).brighter(1.2).toString()
      return new_color.formatHex()
      return 'transparent'
    },
  },
  methods: {
    changeYear(){
      this.$store.dispatch('FETCH_INDICADOR_VALUES', 
        this.new_current_period.year).then(x=>{
      })
    },    
  },
  created(){
    this.new_current_period = this.current_period
  },
  watch:{
    current_period(after, before){
      this.new_current_period = after
    }
  },  
}
</script>

<style lang="scss" scoped>
</style>